import { BaseState } from "..";
import ShipmentDetailsModel from "../../app/data/tracking/ShipmentDetailsModel";

export default interface ShipmentDetailsState extends BaseState {
  shipment?: ShipmentDetailsModel | null;
  error?: string | null;
  needToReload?: boolean;
  dockLogLoading: boolean;
  dockLogLoadingFailed: boolean;
  dockLogLoadingError: string | null;
  dockLogLoaded: boolean;
  dockLog: any;
  statusHistoryLoading: boolean;
  statusHistoryLoadingFailed: boolean;
  statusHistoryLoadingError: string | null;
  statusHistoryLoaded: boolean;
  statusHistory: any;
  addingNote: boolean;
  addingNoteFailed: boolean;
  addingNoteError?: string;
  addingNoteFinished: boolean;
}

export const initialShipmentDetailsState: ShipmentDetailsState = {
  shipment: null,
  error: null,
  loading: false,
  loadingFailed: false,
  loaded: false,
  needToReload: false,
  dockLogLoading: false,
  dockLogLoadingFailed: false,
  dockLogLoadingError: null,
  dockLogLoaded: false,
  dockLog: null,
  statusHistoryLoading: false,
  statusHistoryLoadingFailed: false,
  statusHistoryLoadingError: null,
  statusHistoryLoaded: false,
  statusHistory: null,
  addingNote: false,
  addingNoteFailed: false,
  addingNoteError: "",
  addingNoteFinished: false
};
